const BREAKPOINTS = {
  DESKTOP: 1024
};

const SETTINGS = {
  THROTTLE_DELAY: 500
};

const HEADER = {
  SUBMENU_SELECTOR: '[data-navigation-submenu]',
  HIDDEN_CLASS: '-translate-x-full'
};

const DOM = {
  QTY_SELECTOR_INPUT: '[data-qty-input]'
};

export {
  BREAKPOINTS,
  SETTINGS,
  HEADER,
  DOM
};
